<template>
    <img class="logo-img" src="../../assets/logo_css_tlo.png" alt="">
</template>

<script>
export default {
    name: 'header-logo'
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 700px) {
        @content;
    }
}

@mixin mobileBig {
    @media only screen and (max-width: 1400px) {
        @content;
    }
}
.logo-img {
    @include mobile {
        height: 60px;
    }
}
</style>